// This file was auto generated by resource-sync tools.

import ar_shop_set_web from './ar/shop_set_web.json';
import en_shop_set_web from './en/shop_set_web.json';
import ptBR_shop_set_web from './pt-BR/shop_set_web.json';
import zh_shop_set_web from './zh/shop_set_web.json';
import zhHK_shop_set_web from './zh-HK/shop_set_web.json';
import ar_account_web from './ar/account_web.json';
import en_account_web from './en/account_web.json';
import ptBR_account_web from './pt-BR/account_web.json';
import zh_account_web from './zh/account_web.json';
import zhHK_account_web from './zh-HK/account_web.json';
import ar_marketing_web from './ar/marketing_web.json';
import en_marketing_web from './en/marketing_web.json';
import ptBR_marketing_web from './pt-BR/marketing_web.json';
import zh_marketing_web from './zh/marketing_web.json';
import zhHK_marketing_web from './zh-HK/marketing_web.json';
import ar_b_ad_fe from './ar/b_ad_fe.json';
import en_b_ad_fe from './en/b_ad_fe.json';
import ptBR_b_ad_fe from './pt-BR/b_ad_fe.json';
import zh_b_ad_fe from './zh/b_ad_fe.json';
import zhHK_b_ad_fe from './zh-HK/b_ad_fe.json';
import ar_pos_order_process_web from './ar/pos_order_process_web.json';
import en_pos_order_process_web from './en/pos_order_process_web.json';
import ptBR_pos_order_process_web from './pt-BR/pos_order_process_web.json';
import zh_pos_order_process_web from './zh/pos_order_process_web.json';
import zhHK_pos_order_process_web from './zh-HK/pos_order_process_web.json';
import ar_openapi from './ar/openapi.json';
import en_openapi from './en/openapi.json';
import ptBR_openapi from './pt-BR/openapi.json';
import zh_openapi from './zh/openapi.json';
import zhHK_openapi from './zh-HK/openapi.json';
import ar_b_academy from './ar/b_academy.json';
import en_b_academy from './en/b_academy.json';
import ptBR_b_academy from './pt-BR/b_academy.json';
import zh_b_academy from './zh/b_academy.json';
import zhHK_b_academy from './zh-HK/b_academy.json';
import ar_multi_stores_management from './ar/multi_stores_management.json';
import en_multi_stores_management from './en/multi_stores_management.json';
import ptBR_multi_stores_management from './pt-BR/multi_stores_management.json';
import zh_multi_stores_management from './zh/multi_stores_management.json';
import zhHK_multi_stores_management from './zh-HK/multi_stores_management.json';


const resources = {
    // 'namespaces': 
    // [{"localeInfos":[{"locale":"ar","version":419},{"locale":"en","version":489},{"locale":"pt-BR","version":230},{"locale":"zh","version":351},{"locale":"zh-HK","version":304}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"dtu0qybsds","namespaceName":"shop_set_web"}},{"localeInfos":[{"locale":"ar","version":66},{"locale":"en","version":100},{"locale":"pt-BR","version":57},{"locale":"zh","version":86},{"locale":"zh-HK","version":63}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"olipmd4ssu","namespaceName":"account_web"}},{"localeInfos":[{"locale":"ar","version":506},{"locale":"en","version":629},{"locale":"pt-BR","version":276},{"locale":"zh","version":571},{"locale":"zh-HK","version":463}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"2jvsptqql2","namespaceName":"marketing_web"}},{"localeInfos":[{"locale":"ar","version":5},{"locale":"en","version":456},{"locale":"pt-BR","version":34},{"locale":"zh","version":376},{"locale":"zh-HK","version":361}],"i18nConfig":{"apiKey":"ec21d67c5e924c3b90533d9ea791a836","projectId":19,"namespaceId":"b3ywlb2ytp","namespaceName":"b_ad_fe"}},{"localeInfos":[{"locale":"ar","version":458},{"locale":"en","version":501},{"locale":"pt-BR","version":217},{"locale":"zh","version":447},{"locale":"zh-HK","version":355}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"xop8sebnvt","namespaceName":"pos_order_process_web"}},{"localeInfos":[{"locale":"ar","version":257},{"locale":"en","version":253},{"locale":"pt-BR","version":150},{"locale":"zh","version":309},{"locale":"zh-HK","version":199}],"i18nConfig":{"apiKey":"c8a8b802de0447359433a0aaa8e51bf8","projectId":6,"namespaceId":"9r6pgmjj1c","namespaceName":"openapi"}},{"localeInfos":[{"locale":"ar","version":8},{"locale":"en","version":7},{"locale":"pt-BR","version":8},{"locale":"zh","version":8},{"locale":"zh-HK","version":7}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"9ki0xv9rcg","namespaceName":"b_academy"}},{"localeInfos":[{"locale":"ar","version":15},{"locale":"en","version":15},{"locale":"pt-BR","version":15},{"locale":"zh","version":15},{"locale":"zh-HK","version":13}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"njycynjjri","namespaceName":"multi_stores_management"}}],
    'ar': {
        shop_set_web: ar_shop_set_web,
        account_web: ar_account_web,
        marketing_web: ar_marketing_web,
        b_ad_fe: ar_b_ad_fe,
        pos_order_process_web: ar_pos_order_process_web,
        openapi: ar_openapi,
        b_academy: ar_b_academy,
        multi_stores_management: ar_multi_stores_management
    },
    'en': {
        shop_set_web: en_shop_set_web,
        account_web: en_account_web,
        marketing_web: en_marketing_web,
        b_ad_fe: en_b_ad_fe,
        pos_order_process_web: en_pos_order_process_web,
        openapi: en_openapi,
        b_academy: en_b_academy,
        multi_stores_management: en_multi_stores_management
    },
    'pt-BR': {
        shop_set_web: ptBR_shop_set_web,
        account_web: ptBR_account_web,
        marketing_web: ptBR_marketing_web,
        b_ad_fe: ptBR_b_ad_fe,
        pos_order_process_web: ptBR_pos_order_process_web,
        openapi: ptBR_openapi,
        b_academy: ptBR_b_academy,
        multi_stores_management: ptBR_multi_stores_management
    },
    'zh': {
        shop_set_web: zh_shop_set_web,
        account_web: zh_account_web,
        marketing_web: zh_marketing_web,
        b_ad_fe: zh_b_ad_fe,
        pos_order_process_web: zh_pos_order_process_web,
        openapi: zh_openapi,
        b_academy: zh_b_academy,
        multi_stores_management: zh_multi_stores_management
    },
    'zh-HK': {
        shop_set_web: zhHK_shop_set_web,
        account_web: zhHK_account_web,
        marketing_web: zhHK_marketing_web,
        b_ad_fe: zhHK_b_ad_fe,
        pos_order_process_web: zhHK_pos_order_process_web,
        openapi: zhHK_openapi,
        b_academy: zhHK_b_academy,
        multi_stores_management: zhHK_multi_stores_management
    }
};

export default resources;